;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:lang\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/about\",\"regex\":\"^/([^/]+)/about$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/billing\",\"regex\":\"^/([^/]+)/billing$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/blog\",\"regex\":\"^/([^/]+)/blog$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/blog/:slug\",\"regex\":\"^/([^/]+)/blog/([^/]+)$\",\"paramNames\":[\"lang\",\"slug\"]},{\"path\":\"/:lang/comparisons\",\"regex\":\"^/([^/]+)/comparisons$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/comparisons/firebase-vs-auth0-vs-authflow\",\"regex\":\"^/([^/]+)/comparisons/firebase-vs-auth0-vs-authflow$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/comparisons/supabase-vs-auth0-vs-authflow\",\"regex\":\"^/([^/]+)/comparisons/supabase-vs-auth0-vs-authflow$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/dashboard\",\"regex\":\"^/([^/]+)/dashboard$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/dashboard/activity\",\"regex\":\"^/([^/]+)/dashboard/activity$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/dashboard/add-organization\",\"regex\":\"^/([^/]+)/dashboard/add-organization$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/dashboard/users\",\"regex\":\"^/([^/]+)/dashboard/users$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/forgot-password\",\"regex\":\"^/([^/]+)/forgot-password$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/get-started\",\"regex\":\"^/([^/]+)/get-started$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/pricing\",\"regex\":\"^/([^/]+)/pricing$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/privacy-policy\",\"regex\":\"^/([^/]+)/privacy-policy$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/settings\",\"regex\":\"^/([^/]+)/settings$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/sign-in\",\"regex\":\"^/([^/]+)/sign-in$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/sign-up\",\"regex\":\"^/([^/]+)/sign-up$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/terms-of-service\",\"regex\":\"^/([^/]+)/terms-of-service$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/trial-expired\",\"regex\":\"^/([^/]+)/trial-expired$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/verify-email\",\"regex\":\"^/([^/]+)/verify-email$\",\"paramNames\":[\"lang\"]}],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.10";import * as Sentry from "@sentry/nextjs";

const API_BASE_URL: string =
  (typeof window !== "undefined" && window.location.href.includes("localhost"))
    ? "http://localhost:3001"
    : "https://api.authflow.net"

function getLocalAuthContext(): { token: string | null; emailOwner: string | null } {
  if (typeof window === "undefined") {
    return { token: null, emailOwner: null }
  }

  const tokenMatch = document.cookie.match(/(?:^|;\s*)auth_token=([^;]*)/)
  const userMatch = document.cookie.match(/(?:^|;\s*)user_data=([^;]*)/)
  const token = tokenMatch ? decodeURIComponent(tokenMatch[1]) : null
  const rawUser = userMatch ? decodeURIComponent(userMatch[1]) : null
  if (!rawUser) {
    return { token, emailOwner: null }
  }

  try {
    const user = JSON.parse(rawUser)
    return {
      token,
      emailOwner: user?.email ?? null,
    }
  } catch {
    return { token, emailOwner: null }
  }
}

async function sendBugReportToSupport(feedback: Record<string, unknown>) {
  try {
    const { token, emailOwner } = getLocalAuthContext()
    if (!token || !emailOwner) {
      return
    }

    const reporterName = typeof feedback?.name === "string" ? feedback.name : ""
    const reporterEmail = typeof feedback?.contact_email === "string"
      ? feedback.contact_email
      : (typeof feedback?.email === "string" ? feedback.email : "")
    const message = typeof feedback?.message === "string"
      ? feedback.message
      : "Sentry feedback message unavailable"
    const pageUrl = typeof window !== "undefined" ? window.location.href : ""

    await fetch(`${API_BASE_URL}/org/send-bug-report`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({
        email_owner: emailOwner,
        reporter_name: reporterName,
        reporter_email: reporterEmail,
        message,
        page_url: pageUrl,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
        extra_context: feedback,
        submitted_at: new Date().toISOString(),
      }),
      keepalive: true,
    })
  } catch {
    // Do not block Sentry feedback submission path if support-email forwarding fails.
  }
}

function isClaritySequenceNoise(event: Sentry.ErrorEvent): boolean {
  const error = event.exception?.values?.[0]
  const errorValue = typeof error?.value === "string" ? error.value : ""
  const eventMessage = typeof event.message === "string" ? event.message : ""
  const hasSequenceNullMessage = [errorValue, eventMessage].some((value) =>
    value.includes("Cannot read properties of null") && value.includes("sequence")
  )

  if (!hasSequenceNullMessage) {
    return false
  }

  const hasClarityFrame = (error?.stacktrace?.frames ?? []).some((frame) =>
    typeof frame.filename === "string" && frame.filename.includes("clarity.ms")
  )

  if (hasClarityFrame) {
    return true
  }

  return (event.breadcrumbs ?? []).some((breadcrumb) => {
    const url = typeof breadcrumb.data?.url === "string" ? breadcrumb.data.url : ""
    const message = typeof breadcrumb.message === "string" ? breadcrumb.message : ""
    return (
      url.includes("clarity.ms") ||
      message.includes("antifingerprint not defined yet") ||
      (breadcrumb.category === "console" && message.includes("antifingerprint"))
    )
  })
}

function isDomMutationRemoveChildNoise(event: Sentry.ErrorEvent): boolean {
  const error = event.exception?.values?.[0]
  const messages = [
    typeof error?.value === "string" ? error.value : "",
    typeof event.message === "string" ? event.message : "",
  ]

  const matchesRemoveChildNotFound = messages.some((value) =>
    value.includes("Failed to execute 'removeChild' on 'Node'")
    && value.includes("not a child of this node")
  )

  if (!matchesRemoveChildNotFound) {
    return false
  }

  const hasTranslateLikeBreadcrumb = (event.breadcrumbs ?? []).some((breadcrumb) => {
    const message = typeof breadcrumb.message === "string" ? breadcrumb.message : ""
    return message.includes("font > font")
  })

  // This fingerprint is commonly caused by browser translation/extensions mutating DOM outside React.
  return hasTranslateLikeBreadcrumb || (error?.type === "NotFoundError")
}

function isExtensionRuntimeTabContextNoise(event: Sentry.ErrorEvent): boolean {
  const error = event.exception?.values?.[0]
  const messages = [
    typeof error?.value === "string" ? error.value : "",
    typeof event.message === "string" ? event.message : "",
  ]

  const matchesRuntimeSendMessageTabError = messages.some((value) =>
    value.includes("runtime.sendMessage") && value.includes("Tab not found")
  )

  if (!matchesRuntimeSendMessageTabError) {
    return false
  }

  // This typically originates from injected browser extension scripts that lose tab context.
  return true
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: process.env.NODE_ENV === "development",

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: false,
      blockAllMedia: false,
      unblock: ['button', 'input'],
    }),
    Sentry.browserTracingIntegration(),
    Sentry.feedbackIntegration({
      // Additional Feedback configuration goes in here, for example:
      colorScheme: "auto",
      showBranding: false,
    }),
  ],

  // Performance monitoring
  enabled: process.env.NODE_ENV === "production",

  // Release health

  // Filter out sensitive data
  beforeSend(event) {
    if (isClaritySequenceNoise(event)) {
      return null;
    }

    if (isDomMutationRemoveChildNoise(event)) {
      return null;
    }

    if (isExtensionRuntimeTabContextNoise(event)) {
      return null;
    }

    // Filter out development errors in production
    if (process.env.NODE_ENV === "production" && event.exception) {
      const error = event.exception.values?.[0];
      if (error?.value?.includes("localhost") || error?.value?.includes("127.0.0.1")) {
        return null;
      }
    }

    // Remove sensitive data from breadcrumbs
    if (event.breadcrumbs) {
      event.breadcrumbs = event.breadcrumbs.filter(breadcrumb => {
        // Filter out sensitive API calls
        if (breadcrumb.category === "xhr" || breadcrumb.category === "fetch") {
          const url = breadcrumb.data?.url || "";
          if (url.includes("auth") || url.includes("password") || url.includes("token")) {
            return false;
          }
        }
        return true;
      });
    }

    return event;
  },

  // Ignore certain errors
  ignoreErrors: [
    // Random plugins/extensions
    "top.GLOBALS",
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "http://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "http://loading.retry.widdit.com/",
    "atomicFindClose",
    // Facebook borked
    "fb_xd_fragment",
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    "conduitPage",
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    "Script error.",
    // Avast extension error
    "_avast_submit",
    // Network errors
    "NetworkError",
    "Failed to fetch",
    // React DevTools
    "Download the React DevTools",
    // Browser extension native messaging (password managers, autofill, etc.)
    // Chrome sends this when an extension tries to update a DOM node by ID that no longer exists
    /Object Not Found Matching Id/,
    // Microsoft Clarity async init log (not an error)
    "antifingerprint not defined yet",
    // Clarity runtime null dereference observed during script init/navigation
    /Cannot read properties of null \(reading ['\"]sequence['\"]\)/,
    // Benign React DOM mismatch often caused by browser translation/extensions mutating DOM nodes
    /Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node\./,
    // Algolia search insights middleware can fail when search-insights.js is blocked or unavailable
    /\[insights middleware\]: could not load search-insights\.js/i,
    // Browser extension runtime messaging can fail when tab context is gone (commonly Mobile Safari extensions)
    /Invalid call to runtime\.sendMessage\(\)\. Tab not found\./,
    /runtime\.sendMessage\(\).*Tab not found/i,
  ],

  // Deny URLs that should not be tracked
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
});

Sentry.getClient()?.on("beforeSendFeedback", (feedback) => {
  void sendBugReportToSupport(feedback as unknown as Record<string, unknown>)
})

// Export the hook for navigation instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
